export default "__VITE_ASSET__Ccmd4tet__"